/*
  Top Spinner — "sold as a set of four" (Basecamp todo 518775431).

  Golf cart WHEELS and TIRES (not the wheel & tire sets) are priced per item but can only be sold
  as a set of 4. The PDP renders a marker element (see the `set_of_four` block in templates/product.json):

    <p data-ts-set-of-four="4"
       data-ts-set-of-four-message="..."
       data-ts-unit-price="7500"          <- current variant price, in cents
       data-ts-compare-price="0"          <- compare-at price in cents (0 if not on sale)
       data-ts-money-format="${{amount}}">Wheels must be purchased as a set of four (4).</p>

  Two behaviours:
   1) ENFORCEMENT — block adding to cart (PDP + quick-add + express wallets) unless qty === 4.
   2) DYNAMIC PRICE — the price shown on the PDP multiplies with the quantity (qty 2 = 2x, qty 4 = 4x)
      while the underlying per-item price is untouched. Per Matt: keep the single price intact but
      reflect the running total as the qty changes.

  Listeners are delegated on `document` (capture phase for the blockers) so they also cover the
  quick-add modal, whose product form is injected after load.
*/
(function () {
  var MESSAGE_FALLBACK = 'Quantity for this product must be four.';

  // ---- Shopify's canonical money formatter (Shopify.formatMoney is not exposed on this theme) ----
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }
    var match = (format || '${{amount}}').match(placeholderRegex);
    var value = withDelimiters(cents, 2);
    if (match) {
      switch (match[1]) {
        case 'amount': value = withDelimiters(cents, 2); break;
        case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      }
    }
    return (format || '${{amount}}').replace(placeholderRegex, value);
  }

  function scopeFor(el) {
    return el.closest('product-info') || el.closest('quick-add-modal') || el.closest('.product') || document;
  }

  function markerFor(node) {
    return scopeFor(node).querySelector('[data-ts-set-of-four]');
  }

  function quantityInputFor(form) {
    var id = form.getAttribute('id');
    if (id) {
      var linked = document.querySelector('input[name="quantity"][form="' + id + '"]');
      if (linked) return linked;
    }
    return form.querySelector('input[name="quantity"]') || scopeFor(form).querySelector('input[name="quantity"]');
  }

  function showError(form, message) {
    var host = form.closest('product-form') || form.parentElement;
    var wrapper = host && host.querySelector('.product-form__error-message-wrapper');
    var target = wrapper && wrapper.querySelector('.product-form__error-message');
    if (wrapper && target) {
      target.textContent = message;
      wrapper.removeAttribute('hidden');
      wrapper.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      return;
    }
    window.alert(message);
  }

  function clearError(form) {
    var host = form.closest('product-form') || form.parentElement;
    var wrapper = host && host.querySelector('.product-form__error-message-wrapper');
    if (wrapper) wrapper.setAttribute('hidden', '');
  }

  function isCartAddForm(form) {
    return (form.getAttribute('action') || '').indexOf('/cart/add') !== -1;
  }

  // ---- DYNAMIC PRICE ------------------------------------------------------------------------------
  function updatePriceFromMarker(marker) {
    var unit = parseInt(marker.getAttribute('data-ts-unit-price'), 10);
    if (isNaN(unit)) return;
    var compare = parseInt(marker.getAttribute('data-ts-compare-price'), 10) || 0;
    var format = marker.getAttribute('data-ts-money-format') || '${{amount}}';
    var scope = scopeFor(marker);
    var qtyInput = scope.querySelector('input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (isNaN(qty) || qty < 1) qty = 1;

    var priceWrap = scope.querySelector('[id^="price-"]') || scope.querySelector('.price');
    if (!priceWrap) return;

    var selling = formatMoney(unit * qty, format);
    // The current selling price: .price-item--regular (when not on sale) and .price-item--sale (when on sale).
    priceWrap.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale').forEach(function (el) {
      el.textContent = ' ' + selling + ' ';
    });
    if (compare > 0) {
      var was = formatMoney(compare * qty, format);
      priceWrap.querySelectorAll('.price__sale .price-item--regular, s.price-item, .variant-item__old-price').forEach(function (el) {
        el.textContent = ' ' + was + ' ';
      });
    }
  }

  function refreshPrice(node) {
    var marker = markerFor(node);
    if (marker && marker.getAttribute('data-ts-unit-price') != null) updatePriceFromMarker(marker);
  }

  // Quantity changes fire 'change'/'input' on the quantity field (typing AND the +/- buttons).
  ['change', 'input'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var t = e.target;
      if (t && t.name === 'quantity') refreshPrice(t);
    });
  });

  // Set the correct running total on first paint (and when a quick-add modal opens its form).
  function initAll() {
    document.querySelectorAll('[data-ts-set-of-four][data-ts-unit-price]').forEach(function (marker) {
      updatePriceFromMarker(marker);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // quick-add modals inject their content late — re-init when one is added.
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches && n.matches('[data-ts-set-of-four]') || n.querySelector && n.querySelector('[data-ts-set-of-four][data-ts-unit-price]'))) {
          initAll();
          return;
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // ---- ENFORCEMENT: block "Add to cart" unless qty === 4 (PDP + quick-add modal) ------------------
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM' || !isCartAddForm(form)) return;
    var marker = markerFor(form);
    if (!marker) return;
    var required = parseInt(marker.getAttribute('data-ts-set-of-four'), 10) || 4;
    var input = quantityInputFor(form);
    var qty = input ? parseInt(input.value, 10) : NaN;
    if (qty !== required) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(form, marker.getAttribute('data-ts-set-of-four-message') || MESSAGE_FALLBACK);
      if (input) { input.focus(); if (typeof input.select === 'function') input.select(); }
      return false;
    }
    clearError(form);
  }, true);

  // ---- ENFORCEMENT: block the express wallet buttons (they read the qty field directly) -----------
  document.addEventListener('click', function (event) {
    var btn = event.target.closest &&
      event.target.closest('.shopify-payment-button, shopify-accelerated-checkout, .shopify-payment-button__button');
    if (!btn) return;
    var form = btn.closest('form');
    if (!form || !isCartAddForm(form)) return;
    var marker = markerFor(form);
    if (!marker) return;
    var required = parseInt(marker.getAttribute('data-ts-set-of-four'), 10) || 4;
    var input = quantityInputFor(form);
    var qty = input ? parseInt(input.value, 10) : NaN;
    if (qty !== required) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(form, marker.getAttribute('data-ts-set-of-four-message') || MESSAGE_FALLBACK);
    }
  }, true);
})();
